<template>
  <van-popup
    v-model="show"
    round
    position="bottom"
    closeable
    :style="{ height: '420px' }"
    @close="close"
  >
    <div class="dialog_box">
      <div style="color: #2e4344">开课时间</div>
      <div class="content">
        <div
          @click="selectTime(item, index)"
          v-for="(item, index) in getOptions"
          :key="index"
          :class="
            item.status
              ? select == index
                ? 'sel can time_option'
                : 'can time_option'
              : 'out time_option'
          "
        >
          <div style="margin-top: 4px">{{ item.start }}~~{{ item.end }}</div>
          <div style="font-size: 12px" :class="item.status ? 'canSel' : ''">
            {{
              item.status ? (select == index ? "已选择" : "可选择") : "已过期"
            }}
          </div>
        </div>
      </div>
      <div class="footer">
        <van-button class="sure" @click="sure">确定</van-button>
      </div>
    </div>
  </van-popup>
</template>
<script>
export default {
  name: "course-time-dialog",
  props: {
    time: {
      type: String,
      default() {
        return "";
      },
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    timeShow: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      show: true,
      select: -1,
    };
  },
  mounted() {
    let arr = this.time.split("~");
    if (this.time) {
      this.options.forEach((e1, index) => {
        if (e1.start == arr[0] && e1.end == arr[1]) {
          this.select = index;
        }
      });
    }
  },
  computed: {
    getOptions() {
      return this.options.map((item) => {
        let fl = false;
        let d = new Date(item.start);
        let curr = new Date();
        let mon = curr.getMonth() + 1;
        let c = curr.getFullYear() + "-" + mon + "-" + curr.getDate();
        if (d <= new Date(c)) {
          fl = false;
        } else {
          fl = true;
        }
        return {
          start: item.start,
          end: item.end,
          status: fl,
        };
      });
    },
  },
  methods: {
    selectTime(val, index) {
      if (val.status) {
        if (this.select == index) {
          this.select = -1;
        } else {
          this.select = index;
        }
      } else {
        this.$toast("该场次已开课，请选择其他时间");
      }
    },
    close() {
      this.$emit("closeTimeShow");
    },
    sure() {
      if (this.select != -1) {
        this.$emit(
          "setTime",
          this.options[this.select].start + "~" + this.options[this.select].end,
          this.select
        );
      } else {
        this.$emit("setTime", "", -1);
      }
      this.$emit("closeTimeShow");
    },
  },
};
</script>
<style lang="scss">
.dialog_box {
  text-align: center;
  padding: 20px 0;
  .content {
    margin-top: 12px;
    margin-bottom: 50px;
    text-align: center;
    .time_option {
      width: 331px;
      margin: 8px auto;
      border-radius: 4px;
      font-size: 14px;
      padding: 5px 0;
    }
    .sel {
      border: 1px solid #0091ff !important;
      background: rgba(50, 197, 255, 0.05) !important;
      div {
        color: #0091ff !important;
        line-height: 20px !important;
      }
    }
    .canSel {
      color: #0091ff !important;
    }
    .out {
      background: #f3f6f7;
      div {
        color: #8f8f8f;
        line-height: 20px;
      }
    }
    .can {
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid #e2e2e2;
      div {
        color: #2e4344;
        line-height: 20px;
      }
    }
  }
  .footer {
    width: 100%;
    text-align: center;
    position: fixed;
    bottom: 18px;
    .sure {
      width: 335px;
      height: 40px;
      background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
      border-radius: 22px;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      line-height: 22px;
    }
  }
}
</style>
